// DAS-2951: does this alert contradict what the owner just did?
// Computed client-side from the transaction list the portfolio payload
// already ships (the buy/sell chart dots) — zero extra backend calls.
// Sell-direction alert types mirror alert_urgency_core.SELL_TYPES.
const SELL_TYPES = ['harvest'];

export function alertSide(alertType) {
  return SELL_TYPES.includes((alertType || '').trim().toLowerCase()) ? 'sell' : 'buy';
}

// Returns {verb: 'BUY'|'SELL', daysAgo, quantity} for the most recent
// OPPOSITE-direction trade on the alert's ticker within windowDays, else null.
export function recentOppositeAction(alert, transactions, windowDays = 30, now = Date.now()) {
  if (!alert?.ticker || !Array.isArray(transactions)) return null;
  const ticker = alert.ticker.trim().toUpperCase();
  const opposite = alertSide(alert.alert_type) === 'sell' ? 'B' : 'S';
  let best = null;
  for (const t of transactions) {
    if (!t?.ticker || t.ticker.trim().toUpperCase() !== ticker) continue;
    if (String(t.buysell || '').trim().toUpperCase()[0] !== opposite) continue;
    const when = new Date(t.date).getTime();
    if (isNaN(when) || now - when > windowDays * 86400000 || when > now) continue;
    if (!best || when > best.when) best = { when, quantity: t.quantity };
  }
  if (!best) return null;
  return {
    verb: opposite === 'B' ? 'BUY' : 'SELL',
    daysAgo: Math.max(0, Math.floor((now - best.when) / 86400000)),
    quantity: best.quantity,
  };
}

export function recentActionText(alert, transactions) {
  const hit = recentOppositeAction(alert, transactions);
  if (!hit) return null;
  const days = hit.daysAgo === 0 ? 'today' : hit.daysAgo === 1 ? 'yesterday' : `${hit.daysAgo} days ago`;
  return `you followed up a ${hit.verb} on ${alert.ticker} ${days}`;
}
